import React from 'react'
import { Model } from '@morningtrain/react-resources'

export default class EditFormSmartview extends React.Component {
  static get defaultProps () {
    return {
      ...super.defaultProps,
      size: 'md'
    }
  }

  get heading () {
    return null
  }

  get resourceName () {
    return null
  }

  get fields () {
    return null
  }

  render () {
    return (
      <div className='px-8'>
        <Model resourceName={this.resourceName} submittable>
          {this.fields}
          <div className='form-actions'>
            <input className='w-full' type='submit' value='Gem' />
          </div>
        </Model>
      </div>
    )
  }
}
